module.exports = __webpack_public_path__ + "img/mutlucell-logo.324d2a9b.svg";